export default [
  {
    path: '/pvp-menu',
    name: 'pvp-menu',
    component: () => import('@/views/Pvp/PvpMenu.vue'),
    meta: {
      hasNavigation: false,
      fromUpperTransitionType: 'slide',
      toUpperTransitionType: 'slide',
      requireAuth: true,
      transitionDepth: 1,
      requireMobile: true,
    },
  },
  {
    path: '/pvp-lobby/:id',
    name: 'pvp-lobby',
    component: () => import('@/views/Pvp/PvpLobby.vue'),
    meta: {
      fromUpperTransitionType: 'slide',
      toUpperTransitionType: 'slide',
      hasNavigation: false,
      requireAuth: true,
      transitionDepth: 2,
    },
  },
  {
    path: '/pvp',
    name: 'pvp',
    component: () => import('@/views/Pvp/Pvp.vue'),
    meta: {
      hasNavigation: false,
      requireAuth: true,
      depth: 1,
      transitionDepth: 4,
      hasPassAnimation: true,
      chessboardRoom: true,
    },
  },
];
